import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'components/modals/Dialog';
import DialogTitle from 'components/modals/DialogTitle';
import { getOpportunity } from 'redux/actions/opportunityActions';
import { initialize } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';
import {
  STAGE_OPTIONS,
  getContactLabel,
} from 'constants/opportunity';
import {
  PERMISSIONS,
} from 'constants/misc';
import OpportunityForm from './OpportunityForm';

const OpportunityView = (props) => {
  const {
    toggle, opportunityId, readOnly: readOnlyProps, getOpportunityAction, opportunity, config, user, dispatch,
  } = props;
  const isCanEdinOpportunity = user.permissions.includes(PERMISSIONS.CAN_UPDATE_OPPORTUNITIES);
  const isCanSeeOpportunity = user.permissions.includes(PERMISSIONS.CAN_SEE_OPPORTUNITIES);
  const readOnly = readOnlyProps || !isCanEdinOpportunity;
  const formTitle = readOnly ? 'Preview' : 'Edit opportunity';
  const getInitial = data => (
    {
      id: data.id,
      title: data.title,
      type: isEmpty(data.outlet) ? null : data.outlet.outlet_type,
      stage: STAGE_OPTIONS.find(opt => opt.value === data.stage),
      contact: {
        label: getContactLabel(data.contact),
        value: data.contact.id,
      },
      outlet: {
        label: get(data, 'outlet.name', null),
        value: get(data, 'outlet.id', null),
      },
      account: {
        label: get(data, 'account.name', null),
        value: get(data, 'account.id', null),
      },
      campaign: !isEmpty(get(data, 'sequence.campaign', null)) && {
        label: get(data, 'sequence.campaign.name', null),
        value: get(data, 'sequence.campaign.id', null),
      },
      sequence: {
        label: get(data, 'sequence.name', null),
        value: get(data, 'sequence.id', null),
      },
      coverage: data.mentions.map(mention => ({
        label: mention.article_title,
        value: mention.id,
      })),
      notes: data.notes,
      updatedDate: data.modified_date,
      modifiedBy: data.modified_by,
      circleBackDate: config.opportunityRotting ? data.circle_back_date : undefined,
    }
  );
  const handeGetOpportunity = async () => {
    await getOpportunityAction(opportunityId);
  };
  useEffect(() => {
    handeGetOpportunity();
  }, []);
  const initialValues = opportunity?.loaded ? getInitial(opportunity.data) : {};
  useEffect(() => {
    if (!opportunity?.loaded) return;
    dispatch(initialize('add_opportunity_form', initialValues));
  }, [opportunity.loaded]);


  if (!isCanSeeOpportunity) return <></>;
  return (
    <Dialog open onBackdropClick={toggle}>
      <DialogTitle disableTypography>
        {formTitle}
      </DialogTitle>
      <OpportunityForm
        readOnly={readOnly}
        initialValues={initialValues}
        toggle={toggle}
        isLoading={opportunity?.loading}
      />
    </Dialog>
  );
};

OpportunityView.propTypes = {
  readOnly: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  opportunityId: PropTypes.string.isRequired,
  opportunity: PropTypes.element.isRequired,
  getOpportunityAction: PropTypes.func.isRequired,
  config: PropTypes.shape({
    opportunityRotting: PropTypes.bool,
  }).isRequired,
  user: PropTypes.shape({
    permissions: PropTypes.array.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

OpportunityView.defaultProps = {
  readOnly: false,
};

export default compose(connect(
  state => ({
    opportunity: state.opportunity,
    config: state.config,
    user: state.user,
  }),
  dispatch => ({
    getOpportunityAction: opportunityId => dispatch(getOpportunity(opportunityId)),
    dispatch,
  }),
))(OpportunityView);

